<script lang="ts" setup>
import { computed, inject, ref } from "vue";
import { TranslationService } from "../services/translation.service";
import { OverlaysService } from "../services/overlays.service";
import { EOverlay } from "../EOverlay";
import axios from "axios";
import { IAjaxResponse } from "../Ajax";
import { SITEURL } from "@libTs/cms.globals";
import { vInputText as vInputTextDir } from "../directives/v-input-text";

const vInputText = vInputTextDir;
const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;
const overlaysSvc = inject<OverlaysService>("overlaysSvc") as OverlaysService;

const sendingSuccessful = ref(false);
const isSending = ref(false);
type sendingStatus =
    | "ok"
    | "error"
    | "set-new-pw-mail"
    | "use-reset-pw"
    | number;
const sendingStatus = ref<sendingStatus | null>(null);

const email = ref("");

const formPristine = computed(() => email.value === "");
const formInvalid = computed(() => formPristine.value || email.value === "");

const sendForm = () => {
    if (formInvalid.value || formPristine.value || sendingSuccessful.value) {
        return;
    }

    sendingSuccessful.value = false;
    isSending.value = true;

    axios
        .post<IAjaxResponse>(
            SITEURL +
                "actions/sapShop/set-new-pw-with-timeout/send-change-password-email",
            {
                email: email.value,
            },
            {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            },
        )
        .then(
            // success
            (response) => {
                const data = response.data;
                // console.log(data);

                if (data && data.sent) {
                    sendingSuccessful.value = true;
                    // console.log("Password reset email successfully sent.");
                } else {
                    sendingSuccessful.value = false;
                    sendingStatus.value = data.status;

                    console.warn(
                        "Error " +
                            data.status +
                            ": The email has not been sent. ",
                    );
                }
            },

            // error
            (response) => {
                sendingStatus.value = 500;

                console.warn("Error: No response from server.");
                // console.log(response);
            },
        )
        .finally(() => {
            isSending.value = false;
            email.value = "";
        });
};
</script>

<template>
    <form
        name="form"
        :style="sendingSuccessful ? { display: 'none' } : {}"
        @submit.prevent="sendForm()"
        novalidate
    >
        <div class="mt-10">
            <div class="h2">{{ t("FORGOT_PASSWORD") }}?</div>
            <p class="mt-10" v-html="t('FORGOT_PASSWORD_TEXT')"></p>
        </div>

        <div id="forgotten" class="mt-10">
            <label class="text-f7">E-Mail</label>
            <input
                class="!px-5 !py-3 w-full bg-grey-50 rounded-s input-text-input mt-2"
                type="email"
                name="email"
                v-model="email"
                placeholder="E-Mail"
                required
            />
        </div>

        <div
            class="mt-10"
            :class="{ 'loading-animation': isSending }"
            style="display: inline-block"
        >
            <input
                type="submit"
                class="btn-cb"
                :disabled="
                    formPristine ||
                    formInvalid ||
                    sendingSuccessful ||
                    isSending
                "
                value="Send Link"
            />
        </div>

        <div
            class="mt-10 text-red"
            :style="
                !sendingStatus || sendingStatus == 200
                    ? { display: 'none' }
                    : {}
            "
        >
            <p>{{ t("FORGOT_PASSWORD_ERROR") }}</p>
        </div>

        <div class="mt-10">
            <p>
                <a
                    class="link-text"
                    @click="overlaysSvc.showOverlay(EOverlay.loginForm)"
                    >{{ t("BACK") }}</a
                >
            </p>
        </div>
    </form>

    <!-- sending successful message -->
    <div :style="sendingSuccessful ? {} : { display: 'none' }">
        <div class="mt-10">
            <div class="h2">{{ t("EMAIL_RESET_LINK_SENT") }}</div>
            <p class="mt-10" v-html="t('EMAIL_RESET_FOLLOWUP')"></p>
        </div>
    </div>
</template>
